import React from "react";
import Select from "react-select";
import { Button } from "aible";
import * as Expressions from "types/expression";
import { filterUndefined } from "utils/collect";
import * as RelationUtils from "utils/relation";
import { customMapper, selectOnChangeWrapper } from "utils/select";
import { getAccount } from "containers/Accounts/reducer";
import { getDataset, getDatasetsArr } from "containers/Home/reducer";
import { ColumnValueInput, Labeled, TextValueInput } from "components/Tiles/Sense/Relation/Common";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import LeftJoinIconGray from "images/left-join.svg";
import styles from "components/Tiles/Sense/style.module.css";
import { useSelector } from "@/types/store";
const DEFAULT_CONDITION = {
    key: ""
};
const DATASET_MAPPER = customMapper((d) => `(${d.id}) ${d.name}`);
const getLeftKey = (condition) => {
    if ("key" in condition) {
        return condition.key ?? "";
    }
    else if ("left_key" in condition) {
        return condition.left_key ?? "";
    }
    return "";
};
const getRightKey = (condition) => {
    if ("key" in condition) {
        return condition.key ?? "";
    }
    else if ("right_key" in condition) {
        return condition.right_key ?? "";
    }
    return "";
};
const JoinRelationInput = ({ relation, onChange, isDisabled }) => {
    const tag = RelationUtils.getLatestTag(relation);
    const datasetId = tag?.dataset_id;
    const dataset = useSelector((state) => getDataset(state, datasetId));
    const datasetFolderId = dataset?.folder_id;
    const rightDatasetId = relation.right.tag?.dataset_id === datasetId ? undefined : relation.right.tag?.dataset_id;
    const selectedDataset = useSelector((state) => getDataset(state, rightDatasetId));
    const handleChange = (update) => onChange({
        ...relation,
        ...update
    });
    const handleConditionChange = (conditions, index, update) => {
        const updated = conditions
            .map((x, i) => {
            if (i != index) {
                return x;
            }
            if (update === undefined) {
                return undefined;
            }
            else if (update.left_key === undefined && update.right_key === undefined) {
                return x;
            }
            const pair = {
                left_key: update.left_key ?? getLeftKey(x),
                right_key: update.right_key ?? getRightKey(x)
            };
            if (pair.left_key == pair.right_key) {
                return { key: pair.left_key };
            }
            else {
                return pair;
            }
        })
            .filter(filterUndefined);
        handleChange({ conditions: updated });
    };
    const account = useSelector((state) => getAccount(state, dataset?.account_id));
    const datasets = useSelector((state) => getDatasetsArr(state));
    const accountLabel = account?.name ?? `Account Id: ${dataset?.account_id}`;
    const validDatasets = datasets.filter((d) => d.id !== dataset?.id && d.account_id == dataset?.account_id && d.folder_id === datasetFolderId);
    const { left, right, conditions, suffix } = relation;
    const leftContext = RelationUtils.getOutputContext(left);
    const rightContext = RelationUtils.getOutputContext(right);
    return (React.createElement("div", { className: styles.joinBodyLookup, style: { paddingLeft: "3px", fontSize: "12px", minHeight: "0px" } },
        React.createElement("div", { className: styles.jBold }, selectedDataset ? "Selected Dataset" : "Select Dataset"),
        !RelationUtils.isEqual(left, right) && selectedDataset === undefined ? (React.createElement(Button, { disabled: isDisabled, style: { marginTop: "10px" }, onClick: () => {
                handleChange({ right: left });
            } }, "Reset Dataset to be Joined")) : (React.createElement(Select, { key: selectedDataset?.id, options: DATASET_MAPPER.mapAll(validDatasets), value: DATASET_MAPPER.map(selectedDataset), onChange: selectOnChangeWrapper((d) => {
                if (d === undefined) {
                    handleChange({ right: left });
                }
                else {
                    handleChange({ right: RelationUtils.fromDataset(d) });
                }
            }), placeholder: `Search or Select a Dataset Stored in ${accountLabel}`, isDisabled: isDisabled, isClearable: true })),
        React.createElement("div", { className: styles.jBold, style: { marginTop: "20px" } }, "Lookup Keys"),
        conditions.map((c, i) => (React.createElement("div", { key: `${i}_${getLeftKey(c)} _${getRightKey(c)}`, style: { marginTop: "10px", display: "flex", alignItems: "center" } },
            React.createElement("div", { className: styles.jFlexItem, style: { width: "45%", marginRight: "5px" } },
                React.createElement(Labeled, { label: dataset?.name ?? "" },
                    React.createElement(ColumnValueInput, { value: Expressions.column(getLeftKey(c) ?? ""), onChange: (x) => handleConditionChange(conditions, i, { left_key: x?.column }), context: leftContext, isDisabled: isDisabled }))),
            React.createElement("div", { className: styles.jFlexItem, style: { width: "45%", marginLeft: "5px" } },
                React.createElement(Labeled, { label: selectedDataset?.name || "No Dataset Selected" },
                    React.createElement(ColumnValueInput, { value: Expressions.column(getRightKey(c) ?? ""), onChange: (x) => handleConditionChange(conditions, i, { right_key: x?.column }), context: rightContext, isDisabled: isDisabled }))),
            React.createElement(Button, { onClick: () => handleConditionChange(conditions, i, undefined), style: {
                    padding: "5px",
                    marginLeft: "5px",
                    marginTop: "15px"
                }, disabled: isDisabled },
                React.createElement(FontAwesomeIcon, { icon: faTrash }))))),
        React.createElement(Button, { style: { marginTop: "10px" }, onClick: () => handleChange({
                conditions: conditions.concat([DEFAULT_CONDITION])
            }), disabled: right === undefined }, "Add Lookup Key"),
        React.createElement("div", { className: styles.jBold, style: { marginTop: "20px" } }, "Join Type"),
        React.createElement("div", { className: styles.jFlex, style: { justifyContent: "flex-start" } },
            React.createElement("div", { className: styles.jIcon },
                React.createElement("img", { src: LeftJoinIconGray })),
            "Left (Lookup)"),
        React.createElement("div", { style: { width: "50%", marginTop: "20px" } },
            React.createElement("div", { className: styles.jBold }, "Suffix"),
            React.createElement(TextValueInput, { onChange: (suffix) => handleChange({ suffix }), value: suffix, isDisabled: isDisabled }))));
};
export default JoinRelationInput;
